import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { varAlpha } from '@/theme';

/**
 * As "telas" que ilustram os cases. Montadas com componentes, não capturas: seguem o tema
 * e não envelhecem. Cada case aponta para a sua em `src/site/cases.tsx`.
 */

const diaryEntries = [
  { emoji: '🥣', label: 'Almoço', detail: 'comeu tudo', time: '11:40' },
  { emoji: '😴', label: 'Soneca', detail: '1h20', time: '13:05' },
  { emoji: '📷', label: 'Foto', detail: 'atividade de pintura', time: '15:10' },
];

/** Conecta Kids: o diário do dia de uma turma, como a família vê no aplicativo. */
export function DiaryPreview() {
  return (
    <Box
      aria-hidden
      sx={{
        position: 'relative',
        width: 216,
        mx: 'auto',
        p: 1,
        borderRadius: 5,
        bgcolor: 'grey.900',
        boxShadow: (theme) => theme.vars.customShadows.z24,
      }}
    >
      <Box sx={{ borderRadius: 4, overflow: 'hidden', bgcolor: 'background.paper' }}>
        <Box sx={{ px: 2.5, pt: 3, pb: 2, bgcolor: 'primary.main', color: 'primary.contrastText' }}>
          <Typography variant="caption" sx={{ opacity: 0.8 }}>
            Diário de hoje
          </Typography>
          <Typography variant="h6" component="p">
            Turma do Sol
          </Typography>
        </Box>
        <Stack spacing={1} sx={{ p: 2 }}>
          {diaryEntries.map((entry) => (
            <Stack
              key={entry.label}
              direction="row"
              spacing={1.5}
              sx={{
                alignItems: 'center',
                p: 1.25,
                borderRadius: 2,
                bgcolor: (theme) => varAlpha(theme.vars.palette.grey['500Channel'], 0.08),
              }}
            >
              <Box sx={{ fontSize: 20, lineHeight: 1 }}>{entry.emoji}</Box>
              <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                <Typography variant="subtitle2">{entry.label}</Typography>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  {entry.detail}
                </Typography>
              </Box>
              <Typography variant="caption" sx={{ color: 'text.disabled' }}>
                {entry.time}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Box>
  );
}
